// export const fastpassAVP = 'https://abmhosting.in/fastpass/homepage/avp4/assets/img/logo.png'
export const fastpassAVP = "https://i.imgur.com/kWzFfx2.jpeg";
export const fastPasDa = "https://i.imgur.com/bkxhiqG.png";
